import { Button, Text, Flex } from '@/ui';
import GoogleCalendarIcon from '../icon.svg?react';

type BasicGoogleCalendarButtonProps = {
  message?: string;
  onClick: () => void;
};

export const BasicGoogleCalendarButton = ({
  message = 'Connect Google Calendar',
  onClick,
}: BasicGoogleCalendarButtonProps) => {
  return (
    <Button
      bgColor="#FFF"
      border="1px solid #dadce0"
      borderRadius="full"
      color="#3c4043"
      display="flex"
      fontFamily="Roboto"
      fontSize="14px"
      fontWeight="500"
      h={38}
      justifyContent="center"
      letterSpacing="0.25px"
      overflow="hidden"
      p="0"
      pos="relative"
      px="4"
      transition="background-color .218s"
      type="button"
      _hover={{
        borderColor: '#d2e3fc',
        backgroundColor: 'rgba(66, 133, 244, .04)',
      }}
      onClick={onClick}
    >
      <Flex align="center" gap="2" left={-1} pos="relative">
        <GoogleCalendarIcon />
        <Text>{message}</Text>
      </Flex>
    </Button>
  );
};
